// extracted by mini-css-extract-plugin
export var container = "_2h-0";
export var error = "_2h-9";
export var label = "_2h-5";
export var light = "_2h-6";
export var md = "_2h-3";
export var sm = "_2h-2";
export var thin = "_2h-8";
export var thinBold = "_2h-7";
export var vertical = "_2h-4";
export var xs = "_2h-1";